import Edit from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import Download from '@mui/icons-material/Download'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { useRefData } from '../../hooks/data/useRefData'
import { type SOCSampleWithDocuments } from '../../types/apiModels'

const SOCSamplesList: React.FC<{
  socSamples: SOCSampleWithDocuments[]
  isViewOnly: boolean
  isDownloading: boolean
  handleView: (id: string) => void
  handleEdit: (id: string) => void
  handleDownload: (id: string) => void
  handleDelete: (id: string) => void
}> = ({
  socSamples,
  isViewOnly,
  isDownloading,
  handleView,
  handleEdit,
  handleDownload,
  handleDelete,
}) => {
  const { data: samplingNumberValues } = useRefData('RefSamplingNumber')

  const samplingNumbers = useMemo(() => {
    if (!samplingNumberValues) return null

    return samplingNumberValues.reduce<Record<string, string>>((acc, element) => {
      acc[element.id] = element.es_AR || ''
      return acc
    }, {})
  }, [samplingNumberValues])

  return (
    <Box sx={{ padding: '20px' }}>
      {samplingNumbers && (
        <Box sx={{ width: '100%' }}>
          <Stack spacing={2}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <Typography variant="body1">
                        <b>Número de muestreo</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body1">
                        <b>Fecha de muestreo</b>
                      </Typography>
                    </TableCell>
                    {/* <TableCell align="left">
                      <Typography variant="body1">
                        <b>Estado</b>
                      </Typography>
                    </TableCell> */}
                    <TableCell align="center" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {socSamples &&
                    socSamples.map(socSample => (
                      <TableRow
                        key={socSample.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell align="center">
                          {samplingNumbers[socSample.samplingNumberId]}
                        </TableCell>
                        <TableCell align="center">
                          {dayjs(socSample.sampleDate).format('DD/MM/YYYY')}
                        </TableCell>
                        {/* <TableCell align="center">
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'justify',
                              gap: 1,
                            }}
                          >
                            {socSample.isCompleted ? (
                              <Chip
                                label="Completo"
                                size="small"
                                sx={{
                                  backgroundColor: '#8CD219',
                                  color: '#fff',
                                }}
                              />
                            ) : (
                              <>
                                <Chip
                                  label="Incompleto"
                                  size="small"
                                  sx={{
                                    backgroundColor: '#BFCAC9',
                                    color: '#fff',
                                  }}
                                />
                                <Tooltip arrow title={socSample.uncompletedReason || ''}>
                                  <InfoOutlined
                                    sx={{
                                      fontSize: 20,
                                      color: '#BFCAC9',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </Box>
                        </TableCell> */}
                        <TableCell align="right">
                          <Tooltip arrow title="Ver resultado">
                            <Button
                              sx={{ margin: '5px' }}
                              variant="contained"
                              onClick={() => {
                                handleView(socSample.id)
                              }}
                            >
                              <VisibilityIcon sx={{ fontSize: 20 }} />
                            </Button>
                          </Tooltip>
                          <Tooltip arrow title="Editar">
                            <Button
                              sx={{ margin: '5px' }}
                              variant="contained"
                              onClick={() => {
                                handleEdit(socSample.id)
                              }}
                            >
                              <Edit sx={{ fontSize: 20 }} />
                            </Button>
                          </Tooltip>
                          <Tooltip arrow title="Descargar resultado">
                            <span>
                              <Button
                                aria-label="Descargar resultado"
                                disabled={isDownloading}
                                sx={{ margin: '5px' }}
                                variant="outlined"
                                onClick={() => {
                                  handleDownload(socSample.id)
                                }}
                              >
                                <Download sx={{ fontSize: 20 }} />
                              </Button>
                            </span>
                          </Tooltip>
                          <Tooltip arrow title="Eliminar resultado">
                            <span>
                              <Button
                                aria-label="Eliminar resultado"
                                color="error"
                                disabled={isViewOnly}
                                sx={{ margin: '5px', minWidth: 0 }}
                                variant="outlined"
                                onClick={() => {
                                  handleDelete(socSample.id)
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: 20 }} />
                              </Button>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Box>
      )}
    </Box>
  )
}

export default SOCSamplesList
